import { render, staticRenderFns } from "./TheWalletView.vue?vue&type=template&id=477b8641&scoped=true&"
import script from "./TheWalletView.vue?vue&type=script&lang=js&"
export * from "./TheWalletView.vue?vue&type=script&lang=js&"
import style0 from "./TheWalletView.vue?vue&type=style&index=0&id=477b8641&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477b8641",
  null
  
)

export default component.exports